module.exports = __webpack_public_path__ + "static/maxrec-fb-a9072e8ede3c4e1a9ee5162f8eabea78.png";